var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[(_vm.isLoading && !_vm.clinRec.id)?_c('div',[_vm._v("КР Загружается")]):_c('QuestionPage',{attrs:{"clinRec":_vm.clinRec}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }